module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/spot01_beach-photo-a1b153cafdcb9e874114187df5274d49.jpg";